import { CALL_API } from 'middlewares/api';
import { url } from 'configs/';
const {
  NEWTUBE_API_SERVER,
} = url;

const FETCH_SEARCHLIST_REQUEST = 'PeopleSearch/SEARCHLIST_REQUEST';
const FETCH_SEARCHLIST_SUCCESS = 'PeopleSearch/SEARCHLIST_SUCCESS';
const FETCH_SEARCHLIST_FAIL = 'PeopleSearch/SEARCHLIST_FAIL';

const FETCH_EMPLOYEE_REQUEST = 'PeopleSearch/EMPLOYEE_REQUEST';
const FETCH_EMPLOYEE_SUCCESS = 'PeopleSearch/EMPLOYEE_SUCCESS';
const FETCH_EMPLOYEE_FAIL = 'PeopleSearch/EMPLOYEE_FAIL';

const FETCH_DEPARTMENTMEMBERS_REQUEST = 'PeopleSearch/DEPARTMENTMEMBERS_REQUEST';
const FETCH_DEPARTMENTMEMBERS_SUCCESS = 'PeopleSearch/DEPARTMENTMEMBERS_SUCCESS';
const FETCH_DEPARTMENTMEMBERS_FAIL = 'PeopleSearch/DEPARTMENTMEMBERS_FAIL';

const FETCH_DEPARTMENT_REQUEST = 'PeopleSearch/DEPARTMENT_REQUEST';
const FETCH_DEPARTMENT_SUCCESS = 'PeopleSearch/DEPARTMENT_SUCCESS';
const FETCH_DEPARTMENT_FAIL = 'PeopleSearch/DEPARTMENT_FAIL';


const FETCH_UNDER_DEPARTMENT_REQUEST = 'PeopleSearch/UNDER_DEPARTMENT_REQUEST';
const FETCH_UNDER_DEPARTMENT_SUCCESS = 'PeopleSearch/UNDER_DEPARTMENT_SUCCESS';
const FETCH_UNDER_DEPARTMENT_FAIL = 'PeopleSearch/DEPARTMENT_FAIL';

export default function reducer(state = {
  keyword: '',
  datas: [],
  departmentListDatas: [],
  departmentDatas: [],
  underDepartmentDatas: [],
  page: {},
  departmentListPage: {},
  departmentPage: {},
  underDepartmentPage: {},
  employeeDatas: {},
  isLoading: false,
  isUnderDepartmentLoading: false,
  isDepartmentListLoading: false,
  isDepartmentLoading: false,
  isEmployeeLoading: false,
}, action) {
  switch (action.type) {
    case FETCH_SEARCHLIST_REQUEST:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case FETCH_SEARCHLIST_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        keyword: action.keyword,
        datas: action.response.data,
        page: action.response.meta,
      });
    case FETCH_SEARCHLIST_FAIL:
      return Object.assign({}, state, {
        isLoading: false,
      });
    case FETCH_EMPLOYEE_REQUEST:
      return Object.assign({}, state, {
        isEmployeeLoading: true,
      });
    case FETCH_EMPLOYEE_SUCCESS:
      return Object.assign({}, state, {
        isEmployeeLoading: false,
        employeeDatas: action.response.data,
      });
    case FETCH_EMPLOYEE_FAIL:
      return Object.assign({}, state, {
        isEmployeeLoading: false,
      });
    case FETCH_DEPARTMENTMEMBERS_REQUEST:
      return Object.assign({}, state, {
        isDepartmentLoading: true,
      });
    case FETCH_DEPARTMENTMEMBERS_SUCCESS:
      return Object.assign({}, state, {
        departmentPage: action.response.meta,
        isDepartmentLoading: false,
        departmentDatas: action.response.data,
      });
    case FETCH_DEPARTMENTMEMBERS_FAIL:
      return Object.assign({}, state, {
        isDepartmentLoading: false,
      });
    case FETCH_DEPARTMENT_REQUEST:
      return Object.assign({}, state, {
        isDepartmentListLoading: true,
      });
    case FETCH_DEPARTMENT_SUCCESS:
      return Object.assign({}, state, {
        departmentListPage: action.response.meta,
        isDepartmentListLoading: false,
        departmentListDatas: action.response.data,
      });
    case FETCH_DEPARTMENT_FAIL:
      return Object.assign({}, state, {
        isDepartmentListLoading: false,
      });
    case FETCH_UNDER_DEPARTMENT_REQUEST:
      return Object.assign({}, state, {
        isUnderDepartmentLoading: true,
      });
    case FETCH_UNDER_DEPARTMENT_SUCCESS:
      return Object.assign({}, state, {
        underDepartmentPage: action.response.meta,
        isUnderDepartmentLoading: false,
        underDepartmentDatas: action.response.data,
      });
    case FETCH_UNDER_DEPARTMENT_FAIL:
      return Object.assign({}, state, {
        isUnderDepartmentLoading: false,
      });
    default:
      return state;
  }
}
export function fetchSearchList(keyword, pageNumber) {
  let pageSearchNumber = undefined;
  let pageSize = undefined;
  if (pageNumber) {
    pageSearchNumber = pageNumber;
    if (pageNumber.pageCount) {
      pageSize = pageNumber.pageCount;
    } else {
      pageSize = 10;
      if (pageNumber.pageNumber) pageSearchNumber = pageNumber.pageNumber;
    }
  } else {
    pageSize = 10;
    pageSearchNumber = 1;
  }
  const paramsData = {
    Keyword: keyword,
    PageNumber: pageSearchNumber,
    PageSize: pageSize,
  };
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + `employees/peoplesearch`,
      method: 'GET',
      params: paramsData,
      types: [
        FETCH_SEARCHLIST_REQUEST,
        FETCH_SEARCHLIST_SUCCESS,
        FETCH_SEARCHLIST_FAIL,
      ],
    },
    keyword,
  };
}
export function fetchInfoEmployee(employeeId) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}employees/peoplesearch/${employeeId}/BasicInfo`,
      method: 'GET',
      types: [
        FETCH_EMPLOYEE_REQUEST,
        FETCH_EMPLOYEE_SUCCESS,
        FETCH_EMPLOYEE_FAIL,
      ],
    },
  };
}

export function fetchDepartmentMembers(employeeId, pageNumber) {
  let pageDepartmentNumber = undefined;
  let pageSize = undefined;
  if (pageNumber) {
    pageDepartmentNumber = pageNumber;
    if (pageNumber.pageCount) {
      pageSize = pageNumber.pageCount;
    } else {
      pageSize = 10;
      if (pageNumber.pageNumber) pageDepartmentNumber = pageNumber.pageNumber;
    }
  } else {
    pageSize = 10;
    pageDepartmentNumber = 1;
  }
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}employees/peoplesearch/${employeeId}/DepartmentMembers?pageNumber=${pageDepartmentNumber}&pageSize=${pageSize}`,
      method: 'GET',
      types: [
        FETCH_DEPARTMENTMEMBERS_REQUEST,
        FETCH_DEPARTMENTMEMBERS_SUCCESS,
        FETCH_DEPARTMENTMEMBERS_FAIL,
      ],
    },
  };
}

export function fetchDepartment(departmentId, pageNumber) {
  let pageDepartmentNumber = undefined;
  let pageSize = undefined;
  if (pageNumber) {
    pageDepartmentNumber = pageNumber;
    if (pageNumber.pageCount) {
      pageSize = pageNumber.pageCount;
    } else {
      pageSize = 20;
      if (pageNumber.pageNumber) pageDepartmentNumber = pageNumber.pageNumber;
    }
  } else {
    pageSize = 20;
    pageDepartmentNumber = 1;
  }
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}employees/peoplesearch?DepartmentId=${departmentId}&pageNumber=${pageDepartmentNumber}&pageSize=${pageSize}`,
      method: 'GET',
      types: [
        FETCH_DEPARTMENT_REQUEST,
        FETCH_DEPARTMENT_SUCCESS,
        FETCH_DEPARTMENT_FAIL,
      ],
    },
  };
}

export function fetchUnderDepartment(departmentId, pageNumber) {
  let pageDepartmentNumber = undefined;
  let pageSize = undefined;
  if (pageNumber) {
    pageDepartmentNumber = pageNumber;
    if (pageNumber.pageCount) {
      pageSize = pageNumber.pageCount;
    } else {
      pageSize = 20;
      if (pageNumber.pageNumber) pageDepartmentNumber = pageNumber.pageNumber;
    }
  } else {
    pageSize = 20;
    pageDepartmentNumber = 1;
  }
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}departments/peoplesearch?DepartmentId=${departmentId}&pageNumber=${pageDepartmentNumber}&pageSize=${pageSize}`,
      method: 'GET',
      types: [
        FETCH_UNDER_DEPARTMENT_REQUEST,
        FETCH_UNDER_DEPARTMENT_SUCCESS,
        FETCH_UNDER_DEPARTMENT_FAIL,
      ],
    },
  };
}



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/containers/App/screens/Tube/screens/PeopleSearch/reducers/peopleSearchReducer.js
 **/